import React from 'react';
import styled from 'styled-components';

import { calcRatingScore } from '@src/utils/course';

import Rating from '@src/components/common/rating';

const rateStyle = {
	display: 'flex',
	fontSize: 20,
};

const RatingStarsWrapper = styled.div`
	display: flex;
	align-items: center;
	height: 30px;

	.rating-stars__votes {
		font-size: 14px;
		margin-left: 8px;
	}
`;

interface IRatingStars {
	totalScore: string;
	totalVotes: number;
}

const RatingStars = ({ totalScore, totalVotes }: IRatingStars): JSX.Element => {
	const { score, votes } = calcRatingScore({ totalScore, totalVotes });

	return (
		<RatingStarsWrapper>
			<Rating allowHalf value={totalVotes ? score : 5} style={rateStyle} />
			{votes >= 10 && (
				<span className="rating-stars__votes">{votes}</span>
			)}
		</RatingStarsWrapper>
	);
};

export default RatingStars;
